import { Video } from '../pages/Schedule/SchedulePage';

/**
 * @param name - The full name of the video file. Containing the UUID
 * @returns - A formatted file name, removing the UUID and keeping only the descriptive part.
 */
export const formatVideoName = (name: string): string => {
	name = name.replace(/_/g, ' ').split('-').slice(0, -5).join(' ');
	return name;
};

/**
 * Extracts the UUID from a video title. The UUID consists of the last 5 segments when split by '-'.
 * @param title - The full title of the video file containing the UUID
 * @returns - The UUID string (last 5 segments joined by '-')
 */
export const extractUuidFromTitle = (title: string): string => {
	const titleParts = title.split('-');
	if (titleParts.length > 5) {
		return titleParts.slice(-5).join('-');
	}
	return '';
};

/**
 * Reconstructs the original title format by appending the UUID to a formatted title
 * @param formattedTitle - The human-readable title (formatted)
 * @param uuid - The UUID to append
 * @returns - The title in backend format with underscores and UUID
 */
export const reconstructTitleWithUuid = (formattedTitle: string, uuid: string): string => {
	if (!uuid) return formattedTitle;
	const titleWithUnderscores = formattedTitle.replace(/ /g, '_');
	return `${titleWithUnderscores}-${uuid}`;
};

/**
 * Formats the titles of an array of videos received from the backend. (Replaces underscores with spaces and removes UUIDs)
 * @param videos - An array of Video objects.
 * @returns - An array of Video objects with formatted titles.
 */
export const formatVideoTitles = (videos: Video[]): Video[] => {
	return videos.map(video => ({
		...video,
        uuid: extractUuidFromTitle(video.title),
		title: formatVideoName(video.title),
	}));
};
